import React, { useState, useRef, useEffect, useContext } from 'react';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import { connect } from 'react-redux';
import { Button, Spinner } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Select from "../../../components/AppSelect";
import 'react-datepicker/dist/react-datepicker.css';
import { DateTime, IANAZone } from 'luxon';
import moment from "moment-timezone";

import Grid from '../../../components/Grid';
import { Show } from '../../../hooks/Show';
import { PermissionContext } from '../../../hooks/PermissionContext';
import { formatDateWithoutTimeZone } from '../../../utils/formatDate';
import { isNullOrUndefined } from '../../../utils/functionsUtils';
import RescheduleSolutionSuite from '../../../components/Modal/RescheduleSolutionSuite';
import getSuiteColumns from './columns';

const Swal = require('sweetalert2');

const ReschedulingSuite = ({
  reduxGetClients,
  clients,
  reduxGetLogisticsOperators,
  logisticsOperators,
  reduxGetSuiteAddresses,
  addresses,
  reduxResetAddressForm,
  reduxGetAddress,
  rowEdited,
  reduxPatchReschedule,
  reschedule,
  countries,
  reduxGetCountries,
  reduxResetDepartment,
  reduxResetCity,
  reduxResetNeighborhood,
  reduxResetAddressReschedulingForm,
  reduxGetNovelties,
  novelties,
  reschedulingsByNovelty,
}) => {

  const { hasPermission } = useContext(PermissionContext);

  const modalForm = useForm({
    defaultValues: {
      rescheduleResolution: { value: 1 },
      dateReschedule: null,
      manualAddress: null,
      phone: null,
      country: null,
      countryISO: null,
      department: null,
      city2: null,
      neighborhood: null,
      collection: null,
      observations: null,
    }
  });

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    reset: resetSearch,
    setValue: setValueSearch,
    getValues: getValuesSearch,
  } = useForm({});

  const customStyles = {
    menu: (base) => ({ ...base, zIndex: 9999 }),
    valueContainer: (baseStyles) => ({ ...baseStyles, maxHeight: "3.5vw", overflowY: "auto" }),
    singleValue: (baseStyles) => ({ ...baseStyles, width: "100%" }),
    control: (baseStyles) => ({ ...baseStyles, flexWrap: "nowrap" })
  };

  const rescheduleResolution = modalForm.watch('rescheduleResolution', { value: 1 });

  const rangeRef = useRef()

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange
  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(10);
  const [search, setSearch] = useState('');
  const [isDownloading, setIsDownloading] = useState(false)
  const [showModalReschedule, setShowModalReschedule] = useState(false);
  const [valueManualAddress, setValueManualAddress] = useState('');
  const [filters, setFilters] = useState({})

  useEffect(() => {
    reduxGetNovelties({
      page: 1,
      search: "",
      offset: 1000,
      status: 11,
    });
    reduxGetClients();
    reduxGetLogisticsOperators();
    reduxGetCountries({
      page: 1,
      offset: 1000,
      search: '',
      isActive: true,
    });
    reduxResetAddressForm();
    reduxResetDepartment();
    reduxResetCity();
    reduxResetNeighborhood();

    setDateRange([null, null]);
    resetSearch();
    modalForm.reset();
    setShowModalReschedule(false);
    reschedule = null;
  }, []);

  useEffect(() => {
    if (
      currentPage &&
      addresses &&
      Object.keys(addresses).length > 0 &&
      getValuesSearch('from') &&
      getValuesSearch('to')
    ) {
      let filters = {
        page: currentPage,
        offset: offset,
        search: search,
      };
      if (getValuesSearch('idClient')) {
        filters = {
          ...filters,
          idClient: getValuesSearch('idClient'),
        };
      }
      if (getValuesSearch('idOperator')) {
        filters = {
          ...filters,
          idOperator: getValuesSearch('idOperator'),
        };
      }
      if (getValuesSearch('novelty')) {
        filters = {
          ...filters,
          novelty: getValuesSearch('novelty').value,
        };
      }
      filters = {
        ...filters,
      };
      if (getValuesSearch('from') && getValuesSearch('to')) {
        filters = {
          ...filters,
          from: formatDateWithoutTimeZone(startDate),
          to: formatDateWithoutTimeZone(endDate),
        };
      }
      reduxGetSuiteAddresses(filters);
    }
  }, [currentPage]);

  useEffect(() => {
    if (reschedule) {
      Swal.fire('Proceso exitoso!', `Registro guardado`, 'success');
      setShowModalReschedule(false);
      let filters = {
        page: currentPage,
        offset: offset,
        search: search,
      };
      if (getValuesSearch('idClient')) {
        filters = {
          ...filters,
          idClient: getValuesSearch('idClient'),
        };
      }
      if (getValuesSearch('idOperator')) {
        filters = {
          ...filters,
          idOperator: getValuesSearch('idOperator'),
        };
      }
      if (getValuesSearch('novelty')) {
        filters = {
          ...filters,
          novelty: getValuesSearch('novelty').value,
        };
      }
      filters = {
        ...filters,
      };
      if (getValuesSearch('from') && getValuesSearch('to')) {
        filters = {
          ...filters,
          from: formatDateWithoutTimeZone(startDate),
          to: formatDateWithoutTimeZone(endDate),
        };
      }

      if (!isNullOrUndefined(startDate) && !isNullOrUndefined(endDate)) {
        reduxGetSuiteAddresses(filters);
      }
    }
  }, [reschedule]);

  useEffect(() => {
    if (!rescheduleResolution)
      return;

    if (rescheduleResolution.value !== 2) {
      modalForm.setValue('dateReschedule', null);
      modalForm.setValue('manualAddress', '');
      modalForm.setValue('phone', '');
      modalForm.setValue('observations', '');
    }
  }, [rescheduleResolution])

  const handleCloseReschedule = () => {
    setShowModalReschedule(false);
    reduxResetDepartment();
    reduxResetCity();
    reduxResetNeighborhood();
    reduxResetAddressReschedulingForm();
    modalForm.reset();
  };

  const allowedNoveltiesToSuite = React.useMemo(() => {
    const homologatedCoordinadoraNovelties = [
      { description: 'Direccion incompleta', code: 'N-DIIN' },
      { description: 'Direccion errada', code: 'N-DIER' },
      { description: 'Cliente no recibe - rechazado', code: 'N-CNR' },
      { description: 'Cliente no recibe - sin dinero', code: 'N-CNRS' },
      { description: 'Cliente no localizado', code: 'N-CNL' },
      { description: 'Novedad no recibida', code: 'N-SINO' },
    ];

    if (!Array.isArray(novelties)) return [];
    return novelties.filter(nov => homologatedCoordinadoraNovelties.some(hom => hom.code === nov.code));
  }, [novelties]);

  const getBadgeStatus = (code) => {
    switch (code) {
      case 'REJECTED':
        return (
          <span className={`badge badge-pill badge-danger`}>
            {'Rechazado'}
          </span>
        );
      case 'PENDING_APPROVAL':
        return (
          <span className={`badge badge-pill badge-warning`}>
            {'Pendiente de aprobación'}
          </span>
        );
      case 'APPROVED':
        return (
          <span className={`badge badge-pill badge-success`}>
            {'Aprobado'}
          </span>
        );
      default:
        return null;
    }
  }

  const openReschedule = (row) => {
    if (row.deliveryAttempts === 2) {
      Swal.fire({
        title: 'Señor usuario',
        text: 'Tener presente que se realizará el último intento de reprogramar esta orden',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#21b5ea',
        cancelButtonColor: '#858796',
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cerrar',
      }).then((result) => {
        if (result.isConfirmed) {
          reduxGetAddress({
            id: row.idAddress,
          });
          setShowModalReschedule(true);
          setValueManualAddress('');
        }
      });
    } else {
      reduxGetAddress({
        id: row.idAddress,
      });
      setShowModalReschedule(true);
      setValueManualAddress('');
    }
  };

  const changeEndDate = (dates) => {
    const [start, end] = dates;
    setValueSearch("from", DateTime.fromJSDate(start).setZone(new IANAZone("America/Bogota")).toFormat("yyyy-LL-dd"))
    setValueSearch("to", DateTime.fromJSDate(end).setZone(new IANAZone("America/Bogota")).toFormat("yyyy-LL-dd"))

    setDateRange(dates)
    rangeRef.current.handleFocus()
  };

  const onSubmitSearch = () => {
    if (endDate < startDate) {
      Swal.fire('Información', 'La fecha inicial debe ser  menor a la fecha final , intenta de nuevo', 'info');
      return;
    }
    let filters = {
      page: 1,
      search: search ? search : '',
      offset: offset,
    };
    if (getValuesSearch('idClient')) {
      filters = {
        ...filters,
        idClient: getValuesSearch('idClient'),
      };
    }
    if (getValuesSearch('idOperator')) {
      filters = {
        ...filters,
        idOperator: getValuesSearch('idOperator'),
      };
    }
    if (getValuesSearch('from') && getValuesSearch('to')) {
      filters = {
        ...filters,
        from: formatDateWithoutTimeZone(startDate),
        to: formatDateWithoutTimeZone(endDate),
      };
    }
    if (getValuesSearch('novelty')) {
      filters = {
        ...filters,
        novelty: getValuesSearch('novelty').value,
      };
    }

    filters = {
      ...filters,
    };

    reduxGetSuiteAddresses(filters);
    setFilters(filters)
  };

  const handleChangeMultiSelect = (type, value) => {
    const multi = {
      ...getValuesSearch(type),
      value
    }

    setValueSearch(type, String(multi.value.map(item => item.value)));
  }

  const handleDownloadData = () => {
    setIsDownloading(true);
    if (endDate < startDate) {
      Swal.fire('Información', 'La fecha inicial debe ser  menor a la fecha final , intenta de nuevo', 'info');
      setIsDownloading(false);
      return;
    }
    const fileName = moment(new Date()).tz("America/Bogota").format("YYYY-MM-DD_HHmmss") + "-reschedulings-report.csv";

    let _data = {
      search: search ? search : '',
      fileName,
    };
    if (getValuesSearch('idClient')) {
      _data = {
        ..._data,
        idClient: getValuesSearch('idClient'),
      };
    }
    if (getValuesSearch('idOperator')) {
      _data = {
        ..._data,
        idOperator: getValuesSearch('idOperator'),
      };
    }
    if (getValuesSearch('novelty')) {
      _data = {
        ..._data,
        novelty: getValuesSearch('novelty').value,
      };
    }
    if (getValuesSearch('from') && getValuesSearch('to')) {
      _data = {
        ..._data,
        from: formatDateWithoutTimeZone(startDate),
        to: formatDateWithoutTimeZone(endDate),
      };
    }

    _data = {
      ..._data,
    };

    const token = window.localStorage.getItem("token");

    fetch(`${process.env.REACT_APP_REPORT_URL}/api/v1/reports/reschedulings/suite`, {
      method: "POST",
      body: JSON.stringify(_data),
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.blob())
      .then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = fileName
        document.body.appendChild(a);
        a.click();
        a.remove();
      }).finally(() => setIsDownloading(false));;
  }

  const renderDownloadButton = () => {
    if (
      !addresses?.items?.length ||
      !addresses ||
      Object.keys(addresses).length === 0
    )
      return;

    if (isDownloading) {
      return (
        <Spinner animation="border" variant="primary" />
      );
    }

    return (
      <Button
        className='mr-2'
        variant='primary'
        type='button'
        onClick={handleDownloadData}
        id='btnDownload'>
        Descargar
      </Button>
    );
  }

  const columns = getSuiteColumns({ hasPermission, getBadgeStatus, openReschedule, Show });

  return (
    <div>
      <div className='card shadow mb-4'>
        <div className='card-header py-3 d-flex justify-content-between'>
          <h6 className='m-0 font-weight-bold text-primary'>Listado de Reprogramaciones</h6>
        </div>
        <div className='card-body'>
          <form onSubmit={handleSubmitSearch(onSubmitSearch)}>
            <div className='row mb-1'>
              <div className='form-group col-md-3'>
                <label
                  className='form-label'>
                  Desde - Hasta
                </label>
                <DatePicker
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  ref={rangeRef}
                  selectsDisabledDaysInRange
                  onChange={changeEndDate}
                  dateFormat="yyyy-MM-dd"
                  className={'form-control'}
                  maxDate={new Date()}
                  shouldCloseOnSelect={false}
                  required
                  isClearable
                />
              </div>
              <Show when='feature:show-client-address'>
                <div className='form-group col-md-3'>
                  <label
                    htmlFor='idClient'
                    className='form-label'>
                    Remitente
                  </label>
                  <Select
                    styles={customStyles}
                    isMulti
                    isClearable={true}
                    isDisabled={!startDate || !endDate}
                    {...registerSearch('idClient')}
                    id='idClient'
                    onChange={(value) => handleChangeMultiSelect('idClient', value)}
                    options={
                      clients && Object.keys(clients).length > 0
                        ? clients.items
                          .filter((f) => f.isActive)
                          .map((ele, _key) => ({
                            value: ele.idCompany,
                            label: ele.description,
                          }))
                        : []
                    }
                  />
                </div>
              </Show>
              <Show when='feature:show-operator-address' whenNot={["feature:isClient"]}>
                <div className='form-group col-md-3'>
                  <label
                    htmlFor='idOperator'
                    className='form-label'>
                    Operador
                  </label>
                  <Select
                    styles={customStyles}
                    isClearable={true}
                    isDisabled={!startDate || !endDate}
                    {...registerSearch('idOperator')}
                    isMulti
                    id='idOperator'
                    onChange={(value) => handleChangeMultiSelect('idOperator', value)}
                    options={
                      logisticsOperators &&
                      Object.keys(logisticsOperators).length > 0 &&
                      logisticsOperators.items
                        .filter((f) => f.isActive === true)
                        .map((ele, key) => ({
                          value: ele.idCompany,
                          label: ele.description,
                        }))
                    }
                  />
                </div>
              </Show>
              <div className='form-group col-md-3'>
                <label
                  htmlFor='novelty'
                  className='form-label'>
                  Novedad
                </label>
                <Select
                  styles={customStyles}
                  isClearable={true}
                  isDisabled={!startDate || !endDate}
                  {...registerSearch('novelty')}
                  id='novelty'
                  onChange={(value) => setValueSearch('novelty', value)}
                  options={
                    allowedNoveltiesToSuite
                      .filter((f) => f.isActive === true)
                      .map((ele) => ({
                        value: ele.code,
                        label: ele.description,
                      }))
                  }
                />
              </div>
              <div className='form-group d-flex flex-row align-items-end ml-3'>
                <Button
                  className='mr-2'
                  variant='primary'
                  type='submit'
                  id='btnSearch'>
                  Buscar
                </Button>
                {
                  renderDownloadButton()
                }
              </div>
            </div>
          </form>
          <Grid
            className='stickyAddress'
            cols={columns}
            data={addresses && Object.keys(addresses).length > 0 ? addresses.items : []}
            total={addresses && addresses.hasOwnProperty('total') ? addresses.total : 0}
            page={addresses && Object.keys(addresses).length > 0 ? Number(addresses.page) : currentPage}
            pages={addresses && Object.keys(addresses).length > 0 ? Number(addresses.totalPages) : 0}
            offset={offset}
            onChangePage={(page) => setCurrentPage(page)}
            onChangeRange={(value) => {
              setOffset(value);
              let filters = {
                page: 1,
                offset: value,
                search: search,
              };
              if (getValuesSearch('idClient')) {
                filters = {
                  ...filters,
                  idClient: getValuesSearch('idClient'),
                };
              }
              if (getValuesSearch('idOperator')) {
                filters = {
                  ...filters,
                  idOperator: getValuesSearch('idOperator'),
                };
              }
              if (getValuesSearch('novelty')) {
                filters = {
                  ...filters,
                  novelty: getValuesSearch('novelty').value,
                };
              }

              filters = {
                ...filters,
              };

              if (getValuesSearch('from') && getValuesSearch('to')) {
                if (endDate < startDate) {
                  Swal.fire(
                    'Información',
                    'La fecha inicial debe ser  menor a la fecha final , intenta de nuevo',
                    'info'
                  );
                  return;
                }
                filters = {
                  ...filters,
                  from: formatDateWithoutTimeZone(startDate),
                  to: formatDateWithoutTimeZone(endDate),
                };
              } else {
                return;
              }
              reduxGetSuiteAddresses(filters);
            }}
            defaultValue={search}
            onChangeSearch={(value) => {
              setSearch(value);
              let filters = {
                page: 1,
                offset: offset,
                search: value,
              };
              if (getValuesSearch('novelty')) {
                filters = {
                  ...filters,
                  novelty: getValuesSearch('novelty').value,
                };
              }
              if (getValuesSearch('idClient')) {
                filters = {
                  ...filters,
                  idClient: getValuesSearch('idClient'),
                };
              }
              if (getValuesSearch('idOperator')) {
                filters = {
                  ...filters,
                  idOperator: getValuesSearch('idOperator'),
                };
              }

              filters = {
                ...filters
              };

              if (getValuesSearch('from') && getValuesSearch('to')) {
                if (endDate < startDate) {
                  Swal.fire(
                    'Información',
                    'La fecha inicial debe ser  menor a la fecha final , intenta de nuevo',
                    'info'
                  );
                  return;
                }
                filters = {
                  ...filters,
                  from: formatDateWithoutTimeZone(startDate),
                  to: formatDateWithoutTimeZone(endDate),
                };
              } else {
                return;
              }
              reduxGetSuiteAddresses(filters);
            }}
          />
        </div>
      </div>
      <div>
        <RescheduleSolutionSuite
          show={showModalReschedule}
          onHide={handleCloseReschedule}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    addresses: state.addressState.reschedulingsSuite,
    clients: state.companyState.clients,
    logisticsOperators: state.companyState.logisticsOperators,
    rowEdited: state.addressState.rowEdited,
    reschedule: state.addressState.reschedule,
    cities: state.cityState.cities,
    novelties: state.noveltyState.novelties,
    reschedulingsByNovelty: state.addressState.reschedulingsByNovelty,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetClients: (payload) =>
      dispatch({
        type: 'FETCH_COMPANIESBYSHIPPER_REQUEST',
        value: payload,
      }),
    reduxGetLogisticsOperators: (payload) =>
      dispatch({
        type: 'FETCH_COMPANIESBYLOGISTICSOPERATOR_REQUEST',
        value: payload,
      }),
    reduxGetSuiteAddresses: (payload) =>
      dispatch({
        type: 'FETCH_ADDRESSES_RESCHEDULING_SUITE_REQUEST',
        value: payload,
      }),
    reduxGetCountByNovelty: (payload) =>
      dispatch({
        type: 'FETCH_COUNT_BY_NOVELTY_RESCHEDULING',
        value: payload,
      }),
    reduxResetAddressForm: () =>
      dispatch({
        type: 'RESET_ADDRESS_FORM',
      }),
    reduxPatchReschedule: (payload) =>
      dispatch({
        type: 'FETCH_ADDRESS_RESCHEDULE_REQUEST',
        value: payload,
      }),
    reduxGetAddress: (payload) =>
      dispatch({
        type: 'READ_ADDRESS_REQUEST',
        value: payload,
      }),
    reduxGetNovelties: (payload) =>
      dispatch({
        type: 'FETCH_NOVELTIES_FOR_RESCHEDULE_REQUEST',
        value: payload,
      }),
    reduxGetCities: (payload) =>
      dispatch({
        type: 'FETCH_CITIES_REQUEST',
        value: payload,
      }),
    reduxGetCountries: (payload) =>
      dispatch({
        type: 'FETCH_COUNTRIES_REQUEST',
        value: payload,
      }),
    reduxResetDepartment: (payload) =>
      dispatch({
        type: 'RESET_BYCOUNTRY_DEPARTMENT',
        value: payload,
      }),
    reduxResetCity: (payload) =>
      dispatch({
        type: 'RESET_BYDEPARTMENT_CITY',
        value: payload,
      }),
    reduxResetNeighborhood: (payload) =>
      dispatch({
        type: 'RESET_BYCITY_NEIGHBORHOOD',
        value: payload,
      }),
    reduxResetAddressReschedulingForm: (payload) =>
      dispatch({
        type: 'RESET_ADDRESS_RESCHEDULING_FORM',
        value: payload,
      }),
    reduxResetCountByNovelty: () =>
      dispatch({
        type: 'RESET_TOTAL_BY_NOVELTY_RESCHEDULING',
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReschedulingSuite);
